import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyAction } from 'owa-bundling-light';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "NativePostBoot" */ './lazyIndex'),
    { name: 'NativePostBoot' }
);

export const lazySetupNativeHostPostBoot: LazyAction<
    typeof lazyIndex.setupNativeHostPostBoot,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.setupNativeHostPostBoot);
